const $product = $('.product')
let url_hash = window.location.hash;
let url_hash_1 = window.location.hash;
let url_hash_2 = window.location.hash;
let url_hash_3 = window.location.hash;
let url_hash_4 = window.location.hash;
let url_hash_5 = window.location.hash;

$(document).ready(function() {
  let $pre_select = $('.pre-select');
  if($pre_select.html() === 'Digital Signal Processors' || $pre_select.html() === 'Digitizers' || $pre_select.html() === 'mmWave Block Converters' || $pre_select.html() === 'New Products' || $pre_select.html() === 'RF Subsystems' || $pre_select.html() === 'RF Upconverters / Transmitters' || $pre_select.html() === 'Tuners') {
    $pre_select.addClass('active');
    let $filter = $pre_select.data('filter');
    $product.each(function(){
      if($(this).data('category') !== $filter){
        $(this).addClass('hide');
      }
    });
  }
  else{
    $product.each(function(){
      $(this).removeClass('hide');
    });
  }
});
$('.table-filters__container-inputs .filter-toggle').click(function() {
  let filter = $(this).data('filter');
  if ($(this).hasClass('active')) {
    $('.table-filters__container-inputs .filter-toggle').removeClass('active').removeClass('pre-select');

    $product.each(function() {
      $(this).removeClass('hide');
    });
  } else {
    // Remove hide class from all products
    $product.removeClass('hide');

    // Add hide class to products that do not match the filter
    $product.each(function() {

      if ( $(this).data('category') !== filter ) {
        $(this).addClass('hide');
      }
    });

    // Remove active class from all filter buttons
    $('.table-filters__container-inputs .filter-toggle').removeClass('active');

    // Add active class to the clicked filter button
    $(this).addClass('active');
  }
});
$('.table-filters__container-inputs_1 .filter-toggle').click(function() {
  let filter = $(this).data('filter');
  if ($(this).hasClass('active_1')) {
    $('.table-filters__container-inputs_1 .filter-toggle').removeClass('active_1');
    $product.each(function() {
      $(this).removeClass('hide_1');
    });
  } else {
    // Remove hide class from all products
    $product.removeClass('hide_1');

    // Add hide class to products that do not match the filter
    $product.each(function() {

      if( $(this).data('rx-channels') !== filter ){
        $(this).addClass('hide_1');
      }
    });

    // Remove active class from all filter buttons
    $('.table-filters__container-inputs_1 .filter-toggle').removeClass('active_1');

    // Add active class to the clicked filter button
    $(this).addClass('active_1');
  }
});
$('.table-filters__container-inputs_2 .filter-toggle').click(function() {
  let filter = $(this).data('filter');
  if ($(this).hasClass('active_2')) {
    $('.table-filters__container-inputs_2 .filter-toggle').removeClass('active_2');
    $product.each(function() {
      $(this).removeClass('hide_2');
    });
  } else {
    // Remove hide class from all products
    $product.removeClass('hide_2');

    // Add hide class to products that do not match the filter
    $product.each(function() {
      if( $(this).data('tx-channels') !== filter ){
        $(this).addClass('hide_2');
      }
    });

    // Remove active class from all filter buttons
    $('.table-filters__container-inputs_2 .filter-toggle').removeClass('active_2');

    // Add active class to the clicked filter button
    $(this).addClass('active_2');
  }
});
$('.table-filters__container-inputs_3 .filter-toggle').click(function() {
  let filter = $(this).data('filter');
  if ($(this).hasClass('active_3')) {
    $('.table-filters__container-inputs_3 .filter-toggle').removeClass('active_3');
    $product.each(function() {
      $(this).removeClass('hide_3');
    });
  } else {
    // Remove hide class from all products
    $product.removeClass('hide_3');

    // Add hide class to products that do not match the filter
    $product.each(function() {
      if( $(this).data('fmin') !== filter ) {
        $(this).addClass('hide_3')
      }
    });

    // Remove active class from all filter buttons
    $('.table-filters__container-inputs_3 .filter-toggle').removeClass('active_3');

    // Add active class to the clicked filter button
    $(this).addClass('active_3');
  }
});
$('.table-filters__container-inputs_4 .filter-toggle').click(function() {
  let filter = $(this).data('filter');
  if ($(this).hasClass('active_4')) {
    $('.table-filters__container-inputs_4 .filter-toggle').removeClass('active_4');
    $product.each(function() {
      $(this).removeClass('hide_4');
    });
  } else {
    // Remove hide class from all products
    $product.removeClass('hide_4');

    // Add hide class to products that do not match the filter
    $product.each(function() {
      if( $(this).data('fmax') !== filter ) {
        $(this).addClass('hide_4')
      }
    });

    // Remove active class from all filter buttons
    $('.table-filters__container-inputs_4 .filter-toggle').removeClass('active_4');

    // Add active class to the clicked filter button
    $(this).addClass('active_4');
  }
});

$('.table-filters__container-inputs_5 .filter-toggle').click(function() {
  let filter = $(this).data('filter');
  if ($(this).hasClass('active_5')) {
    $('.table-filters__container-inputs_5 .filter-toggle').removeClass('active_5');
    $product.each(function() {
      $(this).removeClass('hide_5');
    });
  } else {
    // Remove hide class from all products
    $product.removeClass('hide_5');

    // Add hide class to products that do not match the filter
    $product.each(function() {
      if( $(this).data('max-ifbw') !== filter ) {
        $(this).addClass('hide_5')
      }
    });

    // Remove active class from all filter buttons
    $('.table-filters__container-inputs_5 .filter-toggle').removeClass('active_5');

    // Add active class to the clicked filter button
    $(this).addClass('active_5');
  }
});

// Clear functionality - show all when clear is clicked
$('.clear').click(function() {
  // Remove hide class from all products to show all
  $product.removeClass('hide');

  // Remove active class from all filter buttons
  $('.table-filters__container-inputs .filter-toggle').removeClass('active');
});
$('.clear_1').click(function() {
  // Remove hide class from all products to show all
  $product.removeClass('hide_1');

  // Remove active class from all filter buttons
  $('.table-filters__container-inputs_1 .filter-toggle').removeClass('active_1');
});
$('.clear_2').click(function() {
  // Remove hide class from all products to show all
  $product.removeClass('hide_2');

  // Remove active class from all filter buttons
  $('.table-filters__container-inputs_2 .filter-toggle').removeClass('active_2');
});
$('.clear_3').click(function() {
  // Remove hide class from all products to show all
  $product.removeClass('hide_3');

  // Remove active class from all filter buttons
  $('.table-filters__container-inputs_3 .filter-toggle').removeClass('active_3');
});
$('.clear_4').click(function() {
  // Remove hide class from all products to show all
  $product.removeClass('hide_4');

  // Remove active class from all filter buttons
  $('.table-filters__container-inputs_4 .filter-toggle').removeClass('active_4');
});
$('.clear_5').click(function() {
  // Remove hide class from all products to show all
  $product.removeClass('hide_5');

  // Remove active class from all filter buttons
  $('.table-filters__container-inputs_5 .filter-toggle').removeClass('active_5');
});

$('.clear_all').click(function(){
  // Remove hide class from all products to show all
  $product.removeClass('hide');
  $product.removeClass('hide_1');
  $product.removeClass('hide_2');
  $product.removeClass('hide_3');
  $product.removeClass('hide_4');
  $product.removeClass('hide_5');

  // Remove active class from all filter buttons
  $('.table-filters__container-inputs .filter-toggle').removeClass('active');
  $('.table-filters__container-inputs_1 .filter-toggle').removeClass('active_1');
  $('.table-filters__container-inputs_2 .filter-toggle').removeClass('active_2');
  $('.table-filters__container-inputs_3 .filter-toggle').removeClass('active_3');
  $('.table-filters__container-inputs_4 .filter-toggle').removeClass('active_4');
  $('.table-filters__container-inputs_5 .filter-toggle').removeClass('active_5');
});

if (url_hash) {
  $('.table-filters__container-inputs p.filter-toggle[data-name="' + url_hash + '"]').click();
}
if (url_hash_1) {
  $('.table-filters__container-inputs_1 p.filter-toggle[data-name="' + url_hash_1 + '"]').click();
}
if (url_hash_2) {
  $('.table-filters__container-inputs_2 p.filter-toggle[data-name="' + url_hash_2 + '"]').click();
}
if (url_hash_3) {
  $('.table-filters__container-inputs_3 p.filter-toggle[data-name="' + url_hash_3 + '"]').click();
}
if (url_hash_4) {
  $('.table-filters__container-inputs_4 p.filter-toggle[data-name="' + url_hash_4 + '"]').click();
}
if (url_hash_5) {
  $('.table-filters__container-inputs_5 p.filter-toggle[data-name="' + url_hash_5 + '"]').click();
}
$('.view-all').click(function(){
  $(this).siblings('.table-filters__container-inputs').toggleClass('max-height');

  if($(this).html() === 'View All +'){
    $(this).html("View Less -");
  }
  else{
    $(this).html("View All +");
  }
})
$('.view-all_1').click(function(){
  $(this).siblings('.table-filters__container-inputs_1').toggleClass('max-height');

  if($(this).html() === 'View All +'){
    $(this).html("View Less -");
  }
  else{
    $(this).html("View All +");
  }
})
$('.view-all_2').click(function(){
  $(this).siblings('.table-filters__container-inputs_2').toggleClass('max-height');

  if($(this).html() === 'View All +'){
    $(this).html("View Less -");
  }
  else{
    $(this).html("View All +");
  }
})
$('.view-all_3').click(function(){
  $(this).siblings('.table-filters__container-inputs_3').toggleClass('max-height');

  if($(this).html() === 'View All +'){
    $(this).html("View Less -");
  }
  else{
    $(this).html("View All +");
  }
})
$('.view-all_4').click(function(){
  $(this).siblings('.table-filters__container-inputs_4').toggleClass('max-height');

  if($(this).html() === 'View All +'){
    $(this).html("View Less -");
  }
  else{
    $(this).html("View All +");
  }
})
$('.view-all_5').click(function(){
  $(this).siblings('.table-filters__container-inputs_5').toggleClass('max-height');

  if($(this).html() === 'View All +'){
    $(this).html("View Less -");
  }
  else{
    $(this).html("View All +");
  }
});
